'use strict';

import 'Root/product/components/VZDeleteGroup';
import 'Components/prompt';
import { documentReady } from 'app_vodafone_ziggo/util/util';
import initCollapsibleSpecs from 'Components/collapsibleSpecs';

import { VZProductMailModal } from 'Root/product/components/VZProductMailModal';

/**
 * @private onDocumentReady
 */
function onDocumentReady() {
    const basketNotEmpty = document.getElementById('basket-not-empty')?.value;
    if (basketNotEmpty === 'true') {
        new VZProductMailModal(); // eslint-disable-line
    }
}

documentReady(onDocumentReady);
documentReady(initCollapsibleSpecs);
